import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import EcommerceOtpBlockData from 'Models/Content/EcommerceOtpBlockData';
import MainEcommerceOtp from './MainEcommerceOtp';

export default class EcommerceOtpBlock extends EpiComponent<EcommerceOtpBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainEcommerceOtp iContent={this.props.data} context={this.getContext()} />;
  }
}

